// Auto-generated blog post list
// Generated on: 2026-06-18T21:31:13.783Z
// Source: src/blog/*.md — ordered by first git commit (ascending)
// DO NOT EDIT — run npm run generate-blog to regenerate

export const blogPosts = [
  {
    "filename": "0002.md",
    "slug": "0002",
    "title": "VHS Malfunction Effects: The Dramatic Auto-Eject Sequence",
    "description": "A deep dive into creating authentic retro system failures"
  },
  {
    "filename": "0003.md",
    "slug": "0003",
    "title": ">> 0003 AI Projects: Mapping Experiment",
    "description": "I've been doing a few experiments with Claude Code agents, this is one of them."
  },
  {
    "filename": "0004.md",
    "slug": "0004",
    "title": ">> 0004 AI Projects: Using Claude to Master Your D&D Character",
    "description": "What happens when you hand your character sheet to an AI and ask it to find everything you're missing"
  },
  {
    "filename": "0005.md",
    "slug": "0005",
    "title": ">> 0005 AI Projects: Chip Gather",
    "description": "Do you also collect casino chips?"
  },
  {
    "filename": "0006.md",
    "slug": "0006",
    "title": ">> 0006 Music Project",
    "description": "My songwriting/producing page.  Electronic/indie alternative"
  }
];
